import { OptionColors } from "../config/constants";
import { v4 as uuidv4 } from "uuid";

export const NormalizeInput = (input: string): string => {
  return input.toLowerCase().replace(/ /g, "");
};

export const CompareStrings = (
  firstInput: string,
  secondInput: string
): boolean => {
  return NormalizeInput(firstInput) === NormalizeInput(secondInput);
};

export const AddLeadingZero = (value: number): string => {
  return value < 10 && value > 0 ? `0${value}` : `${value}`;
};

export const getDimensions = (node: HTMLDivElement): Dimensions => ({
  width: node.offsetWidth,
  height: node.offsetHeight,
});

export const getOptionColor = (i: number): string => {
  if (i < OptionColors.length) return OptionColors[i];

  return OptionColors[OptionColors.length % i];
};

export const getOptionColorByPrevColor = (prevColor: string): string => {
  const prevIndex = OptionColors.indexOf(prevColor) + 1;

  return getOptionColor(prevIndex);
};

export const GenerateID = (prefix: string): string => {
  return prefix + uuidv4();
};
